var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { mapGetters } from "vuex";
import * as Device from "../device";
export default {
    name: "audio_device_select",
    data: function () {
        return {
            selectedDevice: {},
            unsubscribe: null,
        };
    },
    computed: __assign({}, mapGetters(["currentAudioDevice", "audioDevices"])),
    methods: {
        onChange: function () {
            // Clear previous device errors
            this.$store.dispatch("setAudioDeviceError", { errorId: undefined, deviceName: undefined });
            var device = Device.findDeviceById(this.selectedDevice, this.audioDevices);
            if (!device) {
                this.$store.dispatch("updateCurrentAudioDevice", { deviceId: undefined });
                return;
            }
            this.$store.dispatch("updateCurrentAudioDevice", device);
        },
    },
    beforeMount: function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.currentAudioDevice) {
                    this.selectedDevice = this.currentAudioDevice.deviceId;
                }
                this.unsubscribe = this.$store.subscribe(function (_a) {
                    var type = _a.type;
                    if (type === "currentAudioDevice") {
                        if (_this.currentAudioDevice && _this.currentAudioDevice.deviceId === undefined) {
                            _this.selectedDevice = undefined;
                            return;
                        }
                    }
                    if (type !== "audioDevices")
                        return;
                    if (!_this.currentAudioDevice) {
                        // It is a first time audio devices are loaded. Try to pick preferred device.
                        var preferredDevice = Device.getPreferredDevices().audioDeviceId;
                        _this.selectedDevice = Device.getDefaultFromList(preferredDevice, _this.$store.getters.audioDevices, _this.$store);
                        _this.onChange();
                        return;
                    }
                    var selectedPresent = _this.audioDevices.find(function (_a) {
                        var deviceId = _a.deviceId;
                        return deviceId === _this.selectedDevice;
                    });
                    // Currently selected device is present, so no need to continue.
                    // For Chrome device may change but deviceId is still the same (default, communications).
                    // Call onChange in such case.
                    if (selectedPresent && _this.selectedDevice !== "default" && _this.selectedDevice !== "communications")
                        return;
                    if (_this.selectedDevice === "default" || _this.selectedDevice === "communications") {
                        _this.onChange();
                        return;
                    }
                    _this.selectedDevice = undefined;
                    _this.$store.dispatch("updateCurrentAudioDevice", { deviceId: undefined });
                });
                return [2 /*return*/];
            });
        });
    },
    destroyed: function () {
        if (typeof this.unsubscribe === "function") {
            this.unsubscribe();
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioDeviceSelect.vue
// module id = 324
// module chunks = 1